import { BUTTON_TYPES, Button } from 'components/Button'
import { useFinancialsPopup } from 'features/Financials/Providers/FinancialsPopupProvider'
import { CognusARData } from '../CognusARTable/types'
import { useFinancialsCognusARContext } from 'features/Financials/Providers/FinancialsCognusARProvider'

interface SeeInvoicesButtonProps {
  invoiceBtnText: string
  invoiceData: CognusARData
}

export const SeeInvoicesButton = ({
  invoiceBtnText,
  invoiceData
}: SeeInvoicesButtonProps) => {
  const { invoicesDetailsPopup } = useFinancialsPopup()

  const {
    state: { canSeeInvoicesDetailsOnMarketplaceAR }
  } = useFinancialsCognusARContext()

  return canSeeInvoicesDetailsOnMarketplaceAR ? (
    <Button
      onClick={() => invoicesDetailsPopup.actions.open({ invoiceData })}
      type={BUTTON_TYPES.LINK}
    >
      {invoiceBtnText}
    </Button>
  ) : (
    <>{invoiceBtnText}</>
  )
}
